module.exports = __webpack_public_path__ + "img/log-in-03.a2281f8b.svg";